
export default function GImg({src,alt,className}) {
  return (
    <img src={"https://lh3.googleusercontent.com/d/"+src} alt={alt} className={className}/>
  )
}
